import { Box, SxProps, Theme, Typography } from '@mui/material'
import React from 'react'

interface ReportCardProps {
  styles?: SxProps<Theme>
  title: string
  data: { 
    label: string; 
    value?: string | number; 
    before?: string | number; 
    after?: string | number 
  }[]
}

const ReportBox: React.FC<ReportCardProps> = ({ title, data, styles }) => {
  // Check if data has two-column structure (before, after)
  const hasTwoColumns = data.length > 0 && data[0].before !== undefined && data[0].after !== undefined

  return (
    <Box sx={styles}>
      <Box py={1}>
        <Typography variant='h5' sx={{ color: '#0062C4' }}>
          {title}
        </Typography>
      </Box>
      <Box display='grid' gap={1} sx={{ border: '1px solid #E5E5E5' }}>
        {/* Header row for two-column layout */}
        {hasTwoColumns && (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr',
              alignItems: 'center',
              justifyContent: 'stretch',
              padding: 2,
              backgroundColor: '#f5f5f5',
              borderBottom: '1px solid #E5E5E5',
            }}
          >
            <Typography variant='body2' fontWeight='bold'></Typography>
            <Typography variant='body2' fontWeight='bold' textAlign='center'>
              Before
            </Typography>
            <Typography variant='body2' fontWeight='bold' textAlign='center'>
              After
            </Typography>
          </Box>
        )}
        
        {data.map((row, index) => (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: hasTwoColumns ? '1fr 1fr 1fr' : '1fr 1fr',
              alignItems: 'center',
              justifyContent: 'stretch',
              padding: 2,
            }}
            key={index}
          >
            <Typography variant='body2'>{row.label}</Typography>
            {hasTwoColumns ? (
              <>
                <Typography variant='body2' textAlign='center'>
                  {row.before}
                </Typography>
                <Typography variant='body2' textAlign='center'>
                  {row.after}
                </Typography>
              </>
            ) : (
              <Typography variant='body2' textAlign='right'>
                {row.value}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default ReportBox
